/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Fragment, useState } from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import Background from '../assets/img/brand/imagenlogin.png'
//import logoSantander from '../assets/img/brand/Logo-Santander-Login-2x.png';
import logoIdea2 from '../assets/img/brand/LogoIdea2.jpg';
import iconClose from '../assets/img/icons/cerrarverde.png';
import imagenPublicidad from '../assets/img/brand/Modificación-Horario.jpg'
import horarioJunio from '../assets/img/brand/Modificación-Horario-Junio.jpg'

// core components
import AuthFooter from "components/Footers/AuthFooter.js";
import {useSelector,useDispatch} from "react-redux";

import routes from "routes";

const Auth = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  
  const mostrarFoto=useSelector(state=>state.miga.mostrarImage);

  const [widthdiv, setWidthdiv] = useState('80%');
  const [viewModal, setViewModal] = useState(false);

  React.useEffect(() => {
    document.body.classList.add("bg-white");
    return () => {
      document.body.classList.remove("bg-white");
    };
  }, []);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
    fechaAlertaActivar()
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const fechaAlertaActivar = () => {
    let fechaLimite = new Date(2024, 5, 21);
    let fechaHoy = new Date();
    if (fechaHoy <= fechaLimite) {
      setViewModal(true)
    }
  }

  const cerrarVentana = () => {
    setViewModal(false)
  }

  return (
    <div>
      <div className="d-md-flex half" ref={mainContent}>
        {
          viewModal ? 
          <div className="publicidad">
            <div className="flexrowbetweentop">
              <img
              className="imgcerrar"
              src={iconClose}
              onClick={cerrarVentana} />
              <img
              className="alertacentral"
              src={horarioJunio}
              style={{ height: "15%" }} />
            </div>
          </div> : 
          <Fragment></Fragment>
        }
       {mostrarFoto? <div className="bg" style={{ backgroundImage: `url(${Background})`}}>
          {/* <img className="toast-bottom-left" style={{height:"15%"}} src={logoIdea}></img> */}
        </div>: <div className="ml-5"><img className="ml-3 pr-2" src={logoIdea2} style={{height:"15%"}}/></div>
        }
        
       {mostrarFoto ? <div style={{width:"80%"}}>
          <Container>
            <Row className="row align-items-center justify-content-center">
              <Switch>
                {getRoutes(routes)}
                <Redirect from="*" to="/auth/login" />
              </Switch>
            </Row>
          </Container>
        </div>:<div style={{width:"100%"}}>
          <Container>
            <Row className="row align-items-center justify-content-center">
              
              <Switch>
                {getRoutes(routes)}
                <Redirect from="*" to="/auth/login" />
              </Switch>
            </Row>
          </Container>
        </div>}
      </div>
    </div>
  );
};

export default Auth;
